export interface ChatMessage {
  id: string;
  conversation_id: string;
  sender_id: string;
  body: string;
  attachments: string[] | null;
  created_at: string;
}

export interface ConversationSummary {
  id: string;
  title: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  updated_at: string | null;
  created_by: string;
  participantIds: string[];
  lastMessage: ChatMessage | null;
  lastReadAt: string | null;
  hasUnread: boolean;
}

export interface ConversationListResponse {
  items: ConversationSummary[];
  nextCursor: string | null;
}

export interface RemoveParticipantResponse {
  conversationId: string;
  disbanded: boolean;
  conversation: ConversationSummary | null;
}

export interface MessagesListResponse {
  items: ChatMessage[];
  nextCursor: string | null;
}

export interface MarkConversationReadResponse {
  conversationId: string;
  lastReadAt: string;
}

export interface UnreadSummaryResponse {
  totalUnread: number;
}

export enum NotificationChannel {
  INBOX = 'INBOX',
  BOT_MESSAGE = 'BOT_MESSAGE',
}

export interface NotificationRecord {
  id: string;
  recipientId: string;
  actorId: string | null;
  type: string;
  title: string;
  body: string;
  metadata: Record<string, unknown> | null;
  channels: NotificationChannel[];
  readAt: string | null;
  createdAt: string;
}

export interface NotificationListResponse {
  items: NotificationRecord[];
  nextCursor: string | null;
}

export interface CreateNotificationPayload {
  recipientId: string;
  actorId?: string;
  type: string;
  title: string;
  body: string;
  metadata?: Record<string, unknown>;
  channels?: NotificationChannel[];
}

export interface CreateConversationRequest {
  userId: string;
  participantIds: string[];
  title?: string;
  metadata?: Record<string, unknown>;
}

export interface SendMessageRequest {
  userId: string;
  body: string;
  attachments?: string[];
}
